export default "__VITE_ASSET__CowiLl1K__"